<style scoped>
</style>

<template>
	<v-dialog 
		v-model="visible"
		max-width="400"
		persistent
		no-gutters
	>
		<v-alert
			border="top"
			class="mb-0"
			colored-border
			type="warning"
			icon="mdi-alert-circle"
			transition="scale-transition"
		>
			<div class="pb-3 font-weight-bold text-body-1">
				Rename this worklist as...?
			</div>
			<div>
				<v-text-field
					v-model="worklist.name"
					label="Rename worklist as"
					outlined
					solo
				/>
			</div>
			<div>
				<v-row 
					no-gutters 
					justify="center" 
					v-if="!saving"
				>
					<v-btn 
						outlined 
						@click="close()" 
						color="grey" 
						class="mr-2"
					>
						CANCEL
					</v-btn>
					<v-btn 
						@click="renamewl()" 
						color="light-blue"
						class="white--text"
					>
						OK
					</v-btn>
				</v-row>
				<v-row 
					no-gutters 
					justify="center" 
					v-if="saving"
				>
					<v-progress-circular
						indeterminate
						color="light-blue"
					/>
				</v-row>
			</div>
		</v-alert>
	</v-dialog>
</template>

<script>
import Worklist from "@/models/worklist.js";

export default {
	data() {
		return {
			errormsg: "",
			visible: false,
			saving: false,
			worklist: new Worklist(),
		}
	},

	methods: {
		open(worklist) {
			// just copy our info, should we reload?
			this.worklist.id = worklist.id;
			this.worklist.class = worklist.class;
			this.worklist.name = worklist.name;
			this.worklist.settings = worklist.settings;
			this.worklist.is_dynamic = worklist.is_dynamic;
			this.worklist.details = worklist.details;
			this.worklist.is_pinned = worklist.is_pinned;
			
			// console.log(this.worklist);

			this.errormsg = "";
			this.visible = true;
		},
		renamewl() {
			// Should validate our entry

			this.errormsg = "";
			this.rename = true;

			// console.log('name', this.worklist.name);

			this.worklist.save()
				.then(d => {
					// close dialog
					this.visible = false;

					// rename if is_pinned=true
					if (d.is_pinned) {
						this.$store.dispatch('update_pinned_job_worklists');
					} 
					// let the world know 
					this.$emit('renamed');
				})
				.catch(reason => {
					// record our error message 
					this.errormsg = reason;
				})
				.finally(() => {
					// no longer saving 
					this.rename = false;
				});		
		},
		close() {
			this.visible = false;
		}
	}
}
</script>